import { App } from "@capacitor/app"
import { Browser } from "@capacitor/browser"
import { useRouter } from "vue-router"
import { useDeviceManager } from "../stores/deviceManager"
import { Capacitor } from "@capacitor/core"

export const useDeepLink = () => {
	const router = useRouter()
	const deviceManager = useDeviceManager()

	/**
	 * Registers a listener for deep link events using Capacitor's App plugin.
	 * This functionality is only intended for native iOS and Android devices authentication callbacks.
	 * @returns
	 */
	const initializeDeepLinkListener = (): void => {
		if (deviceManager.operatingSystem !== "ios" && deviceManager.operatingSystem !== "android") return

		// Listen for deep link events
		App.addListener("appUrlOpen", async (event) => {
			// console.log("Deep link opened:", event.url)

			// Close the browser window that was used for OAuth
			await Browser.close().catch((err) => console.warn("Browser already closed:", err))

			try {
				// Parse the deep link URL
				// Example: valormovies://callback?code=abc123&state=xyz
				const url = new URL(event.url)
				// alert("Deep link URL: " + url.toString())

				// Handle OAuth callback
				if (url.pathname === "//callback" || url.host === "callback") {
					const code = url.searchParams.get("code")
					const error = url.searchParams.get("error")

					if (error) {
						router.push("/")
						return
					}

					if (code) {
						// Navigate to callback route with the authorization code
						router.push({
							path: "/callback",
							query: {
								code,
							},
						})
					} else {
						console.warn("No code found in callback URL")
					}
				}
			} catch (error) {
				console.error("Error parsing deep link URL:", error)
			}
		})
	}

	/**
	 * Removes the deep link listener.
	 * @returns
	 */
	const removeDeepLinkListener = async (): Promise<void> => {
		if (
			!(
				deviceManager.operatingSystem === "ios" ||
				deviceManager.operatingSystem === "android" ||
				Capacitor.isNativePlatform()
			)
		)
			return
		await App.removeAllListeners()
	}

	return {
		initializeDeepLinkListener,
		removeDeepLinkListener,
	}
}
